import type { FormLayout, FormLayoutPage } from '../../../../../forms'
import { BasicInfoLayout } from './basic-info'
import { buildLayoutWithCommonSections, layoutFields } from './helpers'
import { NotesLayout } from './notes'

const MachineRoomLayout: FormLayoutPage = {
  key: 'machine-room',
  title: 'Machine Room',
  contents: [
    layoutFields.speed,
    layoutFields.condition,
    layoutFields.accumulatedWear,
    layoutFields.design,
    layoutFields.inherentQuality,
    layoutFields.usage,
    layoutFields.environment,
    layoutFields.technology,
    layoutFields.typeOfUse,
    layoutFields.drivingMachineInstallYear,
    layoutFields.operationalControllerInstallYear,
    layoutFields.typeOfMotorController,
    layoutFields.hasCounterWeights,
    layoutFields.hasMGSet,
    layoutFields.governorType,
    layoutFields.acopumdType,
    layoutFields.driveType,
    layoutFields.hasNonMetallicSheaveLiner,
    layoutFields.hasCoatedRopes,
    layoutFields.hasTractionLossDetection,
    layoutFields.hasBrokenSuspensionDetection,
    layoutFields.hasEmergencyPower,
    layoutFields.isMachineRoomLess,
    layoutFields.brakeType,
    layoutFields.suspensionMembersInstallYear,
    layoutFields.interlocksInstallYear,
    layoutFields.typeOfDoorOperator,
    layoutFields.suspensionMeansType,
    layoutFields.hasSeismicDevices,
    layoutFields.hasBrokenRopeSelectorSwitch,
    layoutFields.guideType,
    layoutFields.doorOperatorManufacturerAndModel,
    layoutFields.controllerManufacturerAndModel,
    layoutFields.drivingMachineManufacturerAndModel,
    { ...layoutFields.numLandings, label: 'Number of Landings' },
    layoutFields.numberOfOpenings,
    layoutFields.doorOpeningMethod,
    layoutFields.doorPanelsType,
    layoutFields.hasHoistwayAccess,
    layoutFields.hasVisionPanels,
    layoutFields.bufferType,
    layoutFields.hasBufferSwitches,
    layoutFields.hasCompensation,
    layoutFields.hasCompensationSheave,
    layoutFields.hasCarSafeties,
    layoutFields.hasCounterweightSafeties,
    layoutFields.numCarsSharePit,
  ],
}

export const MaterialLiftFormLayout: FormLayout = buildLayoutWithCommonSections(
  [BasicInfoLayout, MachineRoomLayout, NotesLayout],
)
